<script>
  import SpotlightItem from './SpotlightItem/SpotlightItem.svelte';

  // Props
  export let id = '';
  export let title = '';
  export let items = [];
</script>

<div {id} class="Spotlight" data-subcategory={title}>
  <span class="title" role="heading" aria-level="2">{title}</span>
  <div class="item-container">
    {#each items as item}
      <SpotlightItem id={item.id} image={item.imageMobile} url={item.url} linkText={item.linkText} />
    {/each}
  </div>
</div>

<style>.Spotlight {
  padding: 12px 25px 20px 25px;
}
.Spotlight .title {
  display: block;
  line-height: 28px;
  margin-bottom: 12px;
}
.Spotlight .item-container {
  display: flex;
  column-gap: 10px;
}
.Spotlight .item-container :global(*) {
  flex: 0.5;
}</style>
